// Utility to count relevant rows for tree tables
export const countRelevantRows = (isTreeTable: boolean) => (rows: unknown[]) => {
  if (!isTreeTable) {
    return rows.length;
  }

  return rows.filter((row: unknown) => {
    const rowObj = row as Record<string, unknown>;
    return rowObj && Array.isArray(rowObj.path) && rowObj.path.length === 1;
  }).length;
};

// Utility to calculate loaded count from pages
export const calculateLoadedCount =
  (countRelevantRowsFn: (rows: unknown[]) => number) => (pages: Array<{ result?: { data?: unknown[] } }>) =>
    pages.reduce((sum, page) => {
      const rows = page.result?.data ?? [];
      return sum + countRelevantRowsFn(rows);
    }, 0);

// Utility to create skeleton rows
export const createSkeletonRows = (count = 10) =>
  Array.from({ length: count }, (_, index) => {
    const skeletonId = `skeleton-${index}`;
    return {
      id: skeletonId,
      _isSkeleton: true,
      path: [skeletonId],
      // Add common ID fields that might be used in getRowId functions
      itemTypeVariantId: skeletonId,
      itemId: skeletonId,
      productName: skeletonId,
      lotNumber: skeletonId,
      productId: skeletonId,
      productionOrderId: skeletonId,
    };
  });
